import React, { useState, useEffect } from "react";
import { sendData, getData, Crypt, DeCrypt } from "../services/auth";
import { uriList } from "../helpers/config";
import { format, parseISO } from 'date-fns'
import { width } from '../helpers'
import logo from './../assets/logo-removebg.png'
import logoAtlas from './../assets/atlas-removebg.png'
import selo from './../assets/selo.png'
import moment from 'moment'
// import './documentos.css' 

const DocumentosTec = (props) => {
  const [cpf, setCPF] = useState("")
  const [documentos, setDocumentos] = useState()
  const [loading, setLoading] = useState(false)
  const [cliente, setCliente] = useState()
  const [tecnico, setTecnico] = useState()

  async function _getData() {
    // return
    console.log("documentos._getData", cpf)
    if ((!documentos || !documentos?.length) && cpf) {
      console.log("documentos._getData(1)", cpf)
      setLoading(true)
      await sendData({
        uri: uriList("documentosTec"),
        content: { cpf },
      })
        .then((res) => {
          console.log("documentostec._getData: ", res.data);

          if (res.status && parseInt(res.status) > 200) throw new Error();
          setDocumentos(res?.data || res);
        })
        .catch((e) => {
          console.log(e);
          alert("Erro ao obter documentos.\n" + e.message);
        });
      setLoading(false)
    }
  }

  useEffect(() => {
    let _cpfcrypt = DeCrypt(props.location?.pathname.replace('/documentostec/', ''))?.replace(/\D/g, '')

    //-- Somente números
    let _cpf = props.location?.pathname.replace('/documentostec/', '').replace(/\D/g, '')

    console.log("documentostec._cpfcrypt: ", _cpfcrypt);

    setCPF(_cpfcrypt || _cpf)
    console.log("documentos.js: ", _cpf);
  }, []);

  useEffect(() => {
    if (cpf)
      _getData();
  }, [cpf]);

  return (
    <div className="d-flex" style={{ height: "100vh", backgroundColor: "white" }}>
      <div className={`${width() == "mobile" ? '' : 'col-3'}`}></div>
      <div
        className={`row ml-0 mt-2 d-flex justify-content-center align-items-center ${width() == "mobile" ? 'col-12' : 'col-6'} `}
        style={{ backgroundColor: "white", }}
      >
        <div style={{
          marginTop: "10px", boxShadow: "rgba(0, 0, 0, 0.50) 1px 1px 1px -1px, rgba(0, 0, 0, 0.20) 1px 1px 1px 1px",
          borderRadius: "5px", border: "1px solid #dee2e6;", padding: "10px",
          backgroundImage: "linear-gradient(to bottom, #F5F5F5, white)"
        }}>
          <div className="d-flex justify-content-center align-items-center mb-4">
            <img className="img-fluid " src={logo} alt="Coalumaq" style={{ maxHeight: "90px", width: width() == "mobile" ? "60%" : "40%" }} />
          </div>
          <div style={{ marginBottom: "15px", justifyContent: "center", alignItems: "center", alignContent: "center", textAlign: "center" }}>
            <div >
              <div ><i style={{ fontSize: "24px", color: "#0D4F4F" }} className="fa fa-users" /></div>
              <div style={{ display: "flex", alignItems: "center", flexDirection: 'column', width: "100%" }}>
                <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "20px", fontWeight: "bold", color: "#116464" }} >Documentos do Técnico</span></div>
              </div>
            </div>
          </div>
          {loading && <div className="d-flex justify-content-center align-items-center text-center text-black mb-5 mt-5"><h6>Carregando dados...</h6></div>}
          {!loading && documentos &&
            <>
              {/* <div className="p-2" style={{ display: "flex", paddingTop: "15px", flexDirection: "column", fontSize: "16px", }}> */}
              <div className="col-12"
                style={{
                  display: "flex", width: "100%", fontSize: "9px", color: 'black', flexDirection: "column", minHeight: "200px",
                  maxHeight: "300px", overflowX: "auto",
                  border: "0.1px solid #ccc", borderRadius: "5px",

                }}>
                <table className="table table-striped rounded" title={"Clique para acessar o documento"} style={{ width: "100%", }}>
                  <thead >
                    {/* <th scope="col" style={{ width: "5%" }}><input type="checkbox" id="cb_baixar_todos" checked={marcarTodos} onClick={handleMarcarTodos} style={{ height: "1.5vh", width: "100%" }} /></th> */}
                    <td scope="col" style={{ width: "10%" }}>*</td>
                    <td scope="col" style={{ width: "70%" }}>Documento</td>
                    <td scope="col" style={{ width: "15%" }}>Validade</td>
                    <td scope="col" style={{ width: "5" }}>Tam.</td>
                  </thead>
                  <tbody>
                    {documentos?.map((doc, index) => {
                      if (!tecnico) {
                        console.log("documentos.doc: ", doc);
                        if (doc.CLIENTE)
                          setCliente(doc.CLIENTE + ' - ' + doc.CNPJ_CPF_CLIENTE)
                        setTecnico(doc.PESSOA + ' - ' + doc.CNPJ_CPF)
                      }

                      return (
                        <tr key={index} style={{ cursor: "pointer" }}>
                          <td style={{ width: "10%" }}><a href={doc.URL_ARQUIVO}><i className="fa fa-download" style={{ color: "black", }} /></a></td>
                          <td style={{ width: "70%" }}><a href={doc.URL_ARQUIVO}>{doc.TIPO_DOCUMENTO}</a></td>
                          <td style={{ width: "15%" }}><a href={doc.URL_ARQUIVO}>{moment(doc.VALIDADE).format('DD/MM/YYYY')}</a></td>
                          <td style={{ width: "5%" }}><a href={doc.URL_ARQUIVO}>{parseFloat((doc.TAMANHO || 0) / 1024 / 1024).toFixed(2)}</a></td>
                        </tr>
                      )
                    })
                    }
                  </tbody>
                </table>
              </div>
              <div className="mb-3 mt-3" style={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                <div clasName="row col-12" style={{ display: "flex", flexDirection: 'column', }}>
                  {cliente &&
                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "12px", color: "black" }} >{cliente}</span></div>
                  }
                  {tecnico &&
                    <div style={{ textAlign: "center", width: "100%" }}><span style={{ fontSize: "10px", color: "black" }} >{tecnico}</span></div>
                  }
                </div>
              </div>
            </>
          }
          <div clasName="row col-12" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img className="img-fluid" src={selo} alt="Site Seguro" style={{ maxHeight: "50px", width: width() == "mobile" ? "30%" : "20%" }} />
          </div>
        </div>
      </div>
      <div className={`${width() == "mobile" ? '' : 'col-3'}`}>

      </div>
    </div>
  );
};

export default DocumentosTec;
